import React from 'react';
import './CartPicker.less';
import {CartPickerTitle} from 'elements/cart-picker-title/CartPickerTitle';

export const CartPicker = ({title, children}) => {
	return (
		<div className="cart-picker">
			<div className="cart-picker__title">
				<CartPickerTitle text={title}/>
			</div>
			<div className="cart-picker__control">{children}</div>
		</div>
	);
};
